module.exports = __webpack_public_path__ + "static/media/lucasg.49c49be5.jpg";